import classNames from 'classnames';
import React from 'react';
interface MessageProps {
  is_author: boolean;
  text: string;
  created_at: string;
  is_seen: boolean;
}
const Message = ({text, is_author, created_at, is_seen}: MessageProps) => {
  const wrapperClassName = classNames(
    'col-span-1 flex flex-col w-fit p-2 gap-2 justify-center text-[18px]  font-medium  shadow-[0_4px_5px_rgba(171,190,209,0.3)]',
    'bar',
    {
      'bg-chat-author  rounded-l-lg rounded-tr-lg items-start text-text-chat-author':
        is_author,
    },
    {
      'bg-Cyan-chat-6  rounded-r-lg rounded-tl-lg items-end text-black':
        !is_author,
    },
  );
  return (
    <div>
      <div className={wrapperClassName}>
        <div className="flex  justify-end text-start text-[14px] break-all">
          {text}
        </div>
        <div className="w-full text-[12px] justify-start flex gap-2 items-center">
          {is_seen && (
            <div
              className={`icon-seen w-[14px] h-[14px] flex text-[10px] ${
                is_author ? ' before:text-white' : 'before:Purple-1'
              }`}
            />
          )}
          <span className={`${is_author ? 'text-time-chat' : 'text-gray-7'}`}>
            {new Date(created_at).toLocaleString('fa-IR', {
              hour: 'numeric',
              minute: 'numeric',
            })}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Message;
